// extracted by mini-css-extract-plugin
export default {"Position":"BTZXc","skeleton-progress":"_5lN82"};